<div class="container-fluid glb-popup">
  <h2>{{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rezConfId" id="rezConfId" type="text" pInputText>
            <label for="rezConfId">Rez Conf Id</label>
            @for (validation of validationMessages.rezConfId; track validation) {
              <span>
                @if (form1.get('rezConfId').hasError(validation.type) && (form1.get('rezConfId').dirty || form1.get('rezConfId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="guestName" id="guestName" type="text" pInputText>
            <label for="guestName">Guest Name</label>
            @for (validation of validationMessages.guestName; track validation) {
              <span>
                @if (form1.get('guestName').hasError(validation.type) && (form1.get('guestName').dirty || form1.get('guestName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="checkInDate" inputId="checkInDate" appendTo="body">
            </p-calendar>
            <label for="checkInDate">CheckIn Date</label>
            @for (validation of validationMessages.checkInDate; track validation) {
              <span>
                @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="checkOutDate" inputId="checkOutDate" appendTo="body">
            </p-calendar>
            <label for="checkOutDate">CheckOut Date</label>
            @for (validation of validationMessages.checkOutDate; track validation) {
              <span>
                @if (form1.get('checkOutDate').hasError(validation.type) && (form1.get('checkOutDate').dirty || form1.get('checkOutDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="numNights" id="numNights" type="number" pInputText>
            <label for="numNights">Num Nights</label>
            @for (validation of validationMessages.numNights; track validation) {
              <span>
                @if (form1.get('numNights').hasError(validation.type) && (form1.get('numNights').dirty || form1.get('numNights').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="ownerNotes" id="ownerNotes" [rows]="2" pInputTextarea></textarea>
            <label for="ownerNotes">Owner Notes</label>
            @for (validation of validationMessages.ownerNotes; track validation) {
              <span>
                @if (form1.get('ownerNotes').hasError(validation.type) && (form1.get('ownerNotes').dirty || form1.get('ownerNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!--Many to One Relation field-->

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="reservationId" optionLabel="propertyCode"
              optionValue="reservationId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property of reservationId">
            </p-dropdown>
            <label for="Select Property of reservationId">Select Property of reservationId</label>
            @for (validation of validationMessages.reservationId; track validation) {
              <span>
                @if (form1.get('reservationId').hasError(validation.type) && (form1.get('reservationId').dirty || form1.get('reservationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <!--ask this about [options], filterby , optionLabel -->

        <!-- <div *ngIf="!ownerStmtRezId" class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="ownerProfiles" formControlName="ownerStmtId" appendTo="body"
            optionLabel="lastName" optionValue="ownerStmtId" (onChange)="selectOwnerStmtId()"
            [filter]="true" filterBy="lastName" [showClear]="false" placeholder="Select Owner Stmt">
          </p-dropdown>
          <label for="Select Owner Stmt">Select Owner Stmt</label>
          <span>
            <small class="p-invalid" *ngIf="ownerStmtIdRequired">Owner profile is required.
              (If Owner Stmt is not here in dropdown, so please add Owner Stmt first and then add Owner Stmt Rez)
            </small>
          </span>
        </span>
      </div> -->

      <!-- <div *ngIf="ownerStmtId" class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="guestRefunds" formControlName="ownerStmtId" appendTo="body" optionLabel="lastName"
          optionValue="ownerStmtId" (onChange)="selectOwnerStmtId()" [filter]="true" filterBy="lastName" [showClear]="false"
          placeholder="Select Owner Stmt">
        </p-dropdown>
        <label for="Select Owner Stmt">Select Owner Stmt</label>
        <span>
          <small class="p-invalid"
            *ngIf="ownerStmtIdRequired">Owner Stmt is required. (If Owner Stmt is not here in dropdown, so please add Owner Stmt first and then add Owner Stmt Rez)
          </small>
        </span>
      </span>
    </div> -->

  </div>

</div>
<hr>

  @if (ownerStmtRezId) {
    <div>
      <div class="col-lg-12">
        <h6>Owner Stmt Rez Detail</h6>
      </div>
      @if (ownerStmtRezId) {
        <app-owner-stmt-rez-detail-list [ownerStmtRezId]="ownerStmtRezId" [showFilter]="false"
        [showPagination]="false"></app-owner-stmt-rez-detail-list>
      }
    </div>
  }

  <hr>

    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (ownerStmtRezId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Owner Stmt Rez</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!ownerStmtRezId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Owner Stmt Rez</button>
            }

            @if (ownerStmtRezId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Owner Stmt Rez</button>
            }
          </div>
        </div>
      </div>
    </div>

  </div>